import React from 'react';

export const TickSquareIcon = ({ width = '25', height = '25', background = 'currentColor', fill = 'black' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height}>
    <path fill={background} d="M0 0h25v25H0z" />
    <path
      fill={fill}
      d="M18.645 6c-.02.02-.72.691-1.611 1.539l-3.194 3.035-3.194 3.036-.59.561L6.1 10.754 4 13.192l5.064 4.373 1.129.978 1.057-1.055c.02-.02.72-.691 1.611-1.539l3.194-3.036 3.194-3.035c.893-.85 1.459-1.387 1.669-1.6z"
    />
  </svg>
);
